import flatpickr from "flatpickr"
import { Polish } from "flatpickr/dist/l10n/pl.js"
import { parse, format, differenceInCalendarDays, isFuture } from "date-fns"
import { formatMoney } from "./format-money"

const DATE_FORMAT = "yyyy-MM-dd"
const WYNAJEM_TYPE_1 = "1"
const WYNAJEM_TYPE_2 = "2"

const fixClickOnIcon = (id: string, fp) => {
  const a = document.getElementById(id)
  if (!a) {
    return
  }
  a.addEventListener("click", (e) => {
    e.preventDefault()
    fp.open()
  })
}

const onChangeDates = (fpInstance, newValue: Date[]) => {
  //   ustawmy wszystkie pola

  const dateFromF = document.getElementById("dateFrom") as HTMLInputElement
  const dateToF = document.getElementById("dateTo") as HTMLInputElement

  if (newValue.length !== 1) {
    return
  }
  if (fpInstance.input.name === "dateFromP") {
    dateFromF.value = format(newValue[0], DATE_FORMAT)
  }
  if (fpInstance.input.name === "dateToP") {
    dateToF.value = format(newValue[0], DATE_FORMAT)
  }
  const wynajemType = getWynajemType()

  const daysFields = document.getElementById("days") as HTMLInputElement
  if (wynajemType === WYNAJEM_TYPE_2) {
    // juz mamy te daty
    const dateFrom = getDateFromInput("dateFrom")
    const dateTo = getDateFromInput("dateTo")

    if (dateFrom && dateTo) {
      const selectedDays =
        Math.abs(differenceInCalendarDays(dateFrom, dateTo)) + 1

      daysFields.value = String(selectedDays)
    } else {
      daysFields.value = String(0)
    }
  } else {
    daysFields.value = String(1)
  }
}

export const setupCarForm = (formId: string) => {
  const form = document.getElementById(formId) as HTMLFormElement

  if (!form) {
    return
  }

  const input = document.getElementById("dateFrom")
  if (!input) {
    return
  }
  const input2 = document.getElementById("dateTo")
  if (!input2) {
    return
  }

  const daysField = document.getElementById("days")
  if (!daysField) {
    return
  }

  const wynajemType = getWynajemType()

  const cont = document.getElementById("dateToCont")
  if (wynajemType === WYNAJEM_TYPE_1) {
    cont.classList.add("hidden")
  }
  if (wynajemType === WYNAJEM_TYPE_2) {
    cont.classList.remove("hidden")
  }

  const flatpickrBaseOptions: {
    mode: "range" | "single"
    locale: any
    disable: any
  } = {
    mode: "single",
    locale: Polish,
    disable: [
      function (date: Date) {
        // return true to disable
        const dateF = format(date, DATE_FORMAT)
        const disabledDays: string[] = (window as any).RESERVATION_DISABLED_DAYS

        const inThePast = !isFuture(date)
        const foundInDisabledDays = disabledDays.indexOf(dateF) !== -1
        const allowSunday = (window as any).RESERVATION_ALLOW_SUNDAY
        const allowSunday2 = allowSunday ? false : date.getDay() === 6
        // console.log("allow sund", allowSunday, allowSunday2)
        return (
          date.getDay() === 0 ||
          allowSunday2 ||
          foundInDisabledDays ||
          inThePast
        )
      },
    ],
  }

  const options = Object.assign({}, flatpickrBaseOptions, {
    onChange: (newValue, dateStr, instance) => {
      onChangeDates(instance, newValue)

      calculatePriceAndShow(form)
    },
  })
  const dateFromP = document.getElementById("dateFromP")
  const dateToP = document.getElementById("dateToP")

  const fp = flatpickr(dateFromP, options)
  const fp2 = flatpickr(dateToP, options)

  fixClickOnIcon("date-icon-1", fp)
  fixClickOnIcon("date-icon-2", fp2)

  // ustawmy datę lub daty
  const dateFrom = getDateFromInput("dateFrom")
  const dateTo = getDateFromInput("dateTo")
  console.log(dateFrom, dateTo)
  if (dateFrom) {
    fp.setDate(dateFrom, true, DATE_FORMAT)
  }
  if (dateTo) {
    fp2.setDate(dateTo, true, DATE_FORMAT)
  }

  const onRadioChange = (c) => {
    const wynajemType = getWynajemType()
    const cont = document.getElementById("dateToCont")

    const selectedDaysF = document.getElementById("days") as HTMLInputElement

    fp.clear()
    fp2.clear()

    if (wynajemType === WYNAJEM_TYPE_1) {
      cont.classList.add("hidden")
      selectedDaysF.value = String(1)
    }
    if (wynajemType === WYNAJEM_TYPE_2) {
      cont.classList.remove("hidden")

      selectedDaysF.value = String(0)
    }

    calculatePriceAndShow(form)
  }

  const radio1F = document.getElementById("typ_wynajmu_1")
  const radio2F = document.getElementById("typ_wynajmu_2")
  radio1F.addEventListener("change", onRadioChange)
  radio2F.addEventListener("change", onRadioChange)

  //   setup onChange options
  const opcje = getOpcje()

  if (opcje.length > 0) {
    for (var i = 0; i < opcje.length; i++) {
      const opcja = opcje[i]
      opcja.addEventListener("change", (e) => {
        calculatePriceAndShow(form as HTMLFormElement)
      })
    }
  }

  // obliczmy cenę
  calculatePriceAndShow(form as HTMLFormElement)
}

const getWynajemType = () => {
  const radio2F = document.getElementById("typ_wynajmu_2") as HTMLInputElement
  if (radio2F.checked) {
    return WYNAJEM_TYPE_2
  }

  return WYNAJEM_TYPE_1
}

const calculatePriceAndShow = (form: HTMLFormElement) => {
  const price = calculatePrice(form)

  const calculatedPriceField = document.getElementById(
    "calculatedPrice"
  ) as HTMLInputElement
  if (calculatedPriceField) {
    calculatedPriceField.value = formatMoney(price, 2, ",", " ") + " zł"
  }
}

const calculatePrice = (form: HTMLFormElement) => {
  let calculatedPrice: number = 0
  const zawieszonyWynajem = form.getAttribute("data-zawieszonyWynajem") === "1"
  const cena14 = parseFloat(form.getAttribute("data-cena14"))
  const cenaPowyzej4 = parseFloat(form.getAttribute("data-cenaPowyzej4"))
  const tylkoZapytanieOCene =
    form.getAttribute("data-tylkoZapytajOCene") === "1"

  if (tylkoZapytanieOCene || zawieszonyWynajem) {
    return null
  }

  const selectedDaysF = document.getElementById("days") as HTMLInputElement
  const selectedDays = parseInt(selectedDaysF.value, 10)

  if (!selectedDays) {
    return null
  }
  const basePrice =
    selectedDays > 4 ? cenaPowyzej4 * selectedDays : cena14 * selectedDays

  calculatedPrice = basePrice
  const opcje = getOpcje()

  if (opcje.length > 0) {
    for (var i = 0; i < opcje.length; i++) {
      const opcja = opcje[i] as HTMLInputElement

      if (opcja.checked) {
        const typOpcji = parseInt(opcja.getAttribute("data-typ_opcji"), 10)
        let cenaOpcji = parseFloat(opcja.getAttribute("data-cena_opcji"))
        const iloscDniOpcjaBezplatna = parseFloat(
          opcja.getAttribute("data-ilosc_dni_opcja_bezplatna")
        )
        // console.log(
        //   "cena opcja ustawiamy na zero",
        //   selectedDays,
        //   iloscDniOpcjaBezplatna
        // )
        if (selectedDays >= iloscDniOpcjaBezplatna) {
          cenaOpcji = 0
        }
        if (typOpcji === 1) {
          calculatedPrice += cenaOpcji
        } else if (typOpcji === 2) {
          calculatedPrice += cenaOpcji * selectedDays
        }
      }
    }
  }

  return calculatedPrice
}

const getOpcje = () => {
  const opcje = document.getElementsByClassName("car-form-option")

  return opcje
}

const getDateFromInput = (
  inputId: string,
  dateFormat: string = DATE_FORMAT
) => {
  const defaultReturn = null
  const field = document.getElementById(inputId)
  if (!field) {
    return defaultReturn
  }
  const value = (field as HTMLInputElement).value
  if (!value) {
    return defaultReturn
  }
  const date = parse(value, dateFormat, new Date())

  return date
}
